<template>
    <b-modal class="lonchera-penalizacion" v-model="displaying" @hidden="onHidden" size="sm" no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header"> 
            Registrar penalización
        </div>
        <div slot="modal-footer">
            <b-button class="mr-3" @click="displaying = false">Cancelar</b-button>
            <b-button variant="danger" :disabled="isProcessing" @click="storeData">
                Penalizar
                <i class="icon icon-easylunch-sadbox confy-icon ml-2"></i> 
            </b-button>
        </div>
        <div v-if="isLoading" class="text-center">
            <b-spinner variant="primary" />
        </div>
        <div v-else class="content">
            <form>
                <b-form-group label="Concepto" label-for="concepto">
                    <b-form-select id="concepto" v-model="form.concepto" :options="opcionesPenalización" @change="updateForm"
                        required></b-form-select>
                </b-form-group>
                <b-form-group label="Cantidad" label-for="cantidad">
                    <b-form-input id="cantidad" type="number" v-model="form.cantidad" required></b-form-input>
                </b-form-group>
                <b-form-group label="Comentarios" label-for="comentarios">
                    <b-form-textarea id="comentarios" v-model="form.comentarios"></b-form-textarea>
                </b-form-group>
            </form>
            <!-- <monedero-quicktable :usuarioId="preFetch.usuario.id" :captions="monederoCaptions" /> -->
        </div>
    </b-modal>
</template>

<script>
import _ from 'lodash'
import { 
    preConfigLonchera, 
    monederoCaptions, 
    recargoArchetype, 
    opcionesPenalización, 
    getCostoSugeridoPenalización, 
    storePenalizacion 
} from './lonchera-penalizacion'
import monederoQuicktable from '@/views/Monedero/quicktable.vue'

const emptyPrefetchState = {
    usuario: {},
    preFetchloncheraHeader: {},
    items: []
};

export default {
    name: 'loncheraPenalizacion',
    components: { monederoQuicktable },
    data: () => {
        return {
            isLoading: false,
            isProcessing: false,
            loncheraId: null,
            displaying: null,
            preFetch: _.clone(emptyPrefetchState),
            form: _.clone(recargoArchetype), opcionesPenalización,
            monederoCaptions
        }
    },
    methods: {
        async storeData(){
            this.isProcessing = true;
            let response = await storePenalizacion(this.loncheraId, this.form)
            this.isProcessing = false;
            if(response.status){
                this.displaying = false;
                this.$emit('refresh')
            }
        },
        updateForm(selectedValue){
            this.form.cantidad = getCostoSugeridoPenalización(selectedValue)
        },
        async penalize(loncheraId) {
            this.loncheraId = loncheraId;
            this.displaying = true;
            this.isLoading = true;
            const response = await preConfigLonchera(this.loncheraId)
            if (response.status) {
                this.preFetch = response.data;
            }
            this.isLoading = false;
        },
        onHidden() {
            this.loncheraId = null;
            this.preFetch = _.clone(emptyPrefetchState);
            this.form = _.clone(recargoArchetype);
        }
    }
}
</script>